import type { TManagerPlanningCockpitSection } from 'partner360/features/financialCockpit/ui/managerPlanningCockpitSwitcher'

export const SECTION_URL_PARAM = 'manager-cockpit-tab'
export const SECTION_URL_VALUES: Record<TManagerPlanningCockpitSection, string> = {
  cockpit: 'cockpit',
  topPartners: 'tp',
  myPartners: 'mp',
  businessPriorities: 'bp',
  marketYoyTargets: 'targets',
  strategicInitiatives: 'si',
  coverageReport: 'cr',
}
